import { createContext } from 'react';
export interface IAddonMainFormContext {
  isReadOnly: boolean;
  isLoading: boolean;
}

export const AddonMainFormContext = createContext<IAddonMainFormContext>({
  isReadOnly: false,
  isLoading: false,
});
